import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Popover,
  PopoverTrigger,
  PopoverContent,
  Modal,
  ModalContent,
  ModalBody,
  useDisclosure,
  addToast
} from "@heroui/react";

import { readContract } from "@wagmi/core";
import stakingAbi from "../../../../abis/nft-staking-abi.json";
import { config } from "webpack";
import { useWallet } from "../../../../context/WalletContext";
import { rainbowKitConfig } from "../../../../utils/config";
import { formatUnits } from "viem";

const NftStakingCard = ({ data, onClick = () => {}, isUnStaking }) => {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  const imgSrc = `https://ipfs.io/ipfs/${data?.image_hash}`;

  return (
    <>
      <div className="card bg-black rounded-2xl p-3 cursor-pointer">
        <div className="relative flex flex-col justify-end">
          <img
            src={imgSrc}
            className="w-full h-[8.375rem] rounded-xl object-cover"
            alt="not-found"
          />

          <div className="card-content rounded-lg bg-[#000000E5] mt-4 p-3">
            <h1 className="m-0 text-xl text-white font-normal leading-[1.5] line-clamp-2">
              {data?.name}
            </h1>

            <div className=" mt-4">
              <Button
                className="flex-1 bg-yellowbuy border border-black rounded-lg text-base w-full h-8 font-semibold text-black"
                onPress={onOpen}
              >
                Unstake
              </Button>
            </div>
          </div>
        </div>
      </div>

      <Modal
        isOpen={isOpen}
        size="sm"
        onOpenChange={onOpenChange}
        classNames={{
          closeButton: "hidden"
        }}
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalBody className="p-4">
                <div className="flex flex-col gap-1">
                  <h1 className="m-0 text-base font-semibold text-black">
                    Are you sure?
                  </h1>
                  <p className="m-0 text-xs text-black">
                    You'll receive only what's earned so far. Are you sure?
                  </p>
                </div>

                <div className="flex items-center justify-center gap-3 mt-4">
                  <Button
                    className="bg-yellowbuy border border-black rounded-lg text-sm h-8"
                    onPress={onClose}
                  >
                    Close
                  </Button>

                  <Button
                    disabled={isUnStaking}
                    isLoading={isUnStaking}
                    className="bg-white border border-black rounded-lg text-sm h-8"
                    onPress={() => onClick(data?.token, data?.address, onClose)}
                  >
                    {isUnStaking ? "Unstake is processing" : "Confirm"}
                  </Button>
                </div>
              </ModalBody>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default NftStakingCard;
